var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6.746V21C32 22.3261 31.4732 23.5979 30.5355 24.5355C29.5979 25.4732 28.3261 26 27 26H5C3.67392 26 2.40215 25.4732 1.46447 24.5355C0.526784 23.5979 0 22.3261 0 21V6.746L15.492 15.862C15.6459 15.9528 15.8213 16.0006 16 16.0006C16.1787 16.0006 16.3541 15.9528 16.508 15.862L32 6.746ZM27 6.19054e-08C28.2303 -0.000193432 29.4175 0.453213 30.3344 1.27348C31.2514 2.09375 31.8337 3.22328 31.97 4.446L16 13.84L0.0300002 4.446C0.166317 3.22328 0.748648 2.09375 1.66559 1.27348C2.58253 0.453213 3.76971 -0.000193432 5 6.19054e-08H27Z",
    fill: "#E66100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/EmailSent.46fd7cb8f7883166115af3973d19b50a.svg";
export { ForwardRef as ReactComponent };